module.exports = __webpack_public_path__ + "static/media/pic2.592e63b2.jpg";